import { render, staticRenderFns } from "./SelectTaxonomy.vue?vue&type=template&id=5dcd4794"
import script from "./SelectTaxonomy.vue?vue&type=script&lang=js"
export * from "./SelectTaxonomy.vue?vue&type=script&lang=js"
import style0 from "./SelectTaxonomy.vue?vue&type=style&index=0&id=5dcd4794&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports